'use client';

import { Box } from '@mui/material';
import { ElementViewed } from '@repo/segment/Analytics/ElementViewed';
import { DesktopTOCWithProgressBar } from '../../../TableOfContents/DesktopTOCWithProgressBar';
import type { TableOfContentsHeadingProps } from '../../../TableOfContents/types';
import { useTableOfContents } from '../../../TableOfContents/useTableOfContents';
import { COMPONENT_ID_DESKTOP } from '../../../TableOfContents/utils';
import { STICKY_SIDE_BAR_WIDTH } from './constants';
import { ShadowContainer } from './ShadowContainer';

type Props = {
  top?: number;
  headings: TableOfContentsHeadingProps[];
};

export function StickySideBar({ top = 15, headings }: Props) {
  const { activeId, setActiveId, fireNavigateToSectionPageAction } = useTableOfContents({
    headings,
  });

  return (
    <Box
      id="review-sidebar"
      role="complementary"
      aria-label="Review sidebar"
      sx={{
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
      }}
    >
      <Box
        id="sidebar-sticky-container"
        sx={{
          display: 'flex',
          position: 'sticky',
          top,
          alignSelf: 'flex-start',
          zIndex: 1,
          margin: -1, // Absorb spacing for shadows
          width: STICKY_SIDE_BAR_WIDTH,
          flexShrink: 0,
        }}
      >
        <ShadowContainer
          containerSx={{
            padding: 3,
            paddingTop: 2,
          }}
        >
          <ElementViewed
            entityName="table_of_contents"
            sectionName="table_of_contents"
            pageType="review"
          >
            {({ fireElementInteracted }) => (
              <Box>
                <DesktopTOCWithProgressBar
                  distanceToSectionWrapper={1}
                  headingLevel={2}
                  headings={headings}
                  tocId={COMPONENT_ID_DESKTOP}
                  activeId={activeId}
                  setActiveId={setActiveId}
                  fireNavigateToSectionPageAction={fireNavigateToSectionPageAction}
                  fireElementInteracted={fireElementInteracted}
                />
              </Box>
            )}
          </ElementViewed>
        </ShadowContainer>
      </Box>
    </Box>
  );
}
